import { render, staticRenderFns } from "./AttachmentPage.vue?vue&type=template&id=92aab42a&scoped=true"
import script from "./AttachmentPage.vue?vue&type=script&lang=js"
export * from "./AttachmentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92aab42a",
  null
  
)

export default component.exports